const ISSERVER = typeof window === "undefined";


//user operations
export const getsessionuser = () => {
    if (!ISSERVER) {
        const userobject = sessionStorage?.getItem("user");
        if (userobject) return JSON.parse(userobject);
        else return null;
    }
}
export const setsessionuser = (user) => {
    sessionStorage?.setItem("user", JSON.stringify(user));
}
export const setlocaluser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
}
export const logoutuser = () => {
    localStorage?.removeItem("user");
    sessionStorage?.removeItem("user")
    sessionStorage?.removeItem("cart")
    sessionStorage?.removeItem("house")
}










